import { Select as GlueSelect } from '@tencent/glue-react-ui';
import { withAdpCombine } from '../../config/context/config';
var AdpCombineSelect = withAdpCombine(GlueSelect);
var AdpCombineSelectOption = withAdpCombine(GlueSelect.Option);
export var Select = Object.assign(AdpCombineSelect, {
  Option: AdpCombineSelectOption
});